import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { STATUS_APPROVALS } from '@consts';
import { EquipmentsApi } from '@core/api/equipments/equipments.api';
import { Company } from '@core/interfaces';
import { clearEmptyProperties, mapCheckbox } from '@core/utils/filters-utils';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import * as _ from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import english from '../i18n/en.json';
import spanish from '../i18n/es.json';
import portuguese from '../i18n/pt.json';

@Component({
  selector: 'filter-approvals-equipments',
  templateUrl: './filter-approvals-equipments.component.html',
  encapsulation: ViewEncapsulation.None
})
export class FilterApprovalsEquipmentsComponent implements OnInit {

  public filterChanged = new BehaviorSubject<any>({ status_in: ['pending'] });

  public filtersForm: FormGroup;
  public types: any[] = [];
  public locations: any[] = [];
  public STATUS: any[] = STATUS_APPROVALS;
  public companies: Company[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private equipmentsApi: EquipmentsApi,
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  get status(): FormArray {
    return this.filtersForm.get('status') as FormArray;
  }

  ngOnInit(): void {

    this.equipmentsApi.getFiltersData().subscribe((result) => {
      this.types = _.clone(result['equipmentsTypes']['items']);
      this.locations = _.clone(result['locations']['items']);
      this.companies = _.clone(result['companies']['items']);
    });

    this.filtersForm = this.formBuilder.group({
      status: this.formBuilder.array(STATUS_APPROVALS.map((situation) => {
        if (situation.name === 'pending') {
          return this.formBuilder.control(true);
        }
        return this.formBuilder.control(false);
      })),
      number: null,
      name: null,
      typeId: null,
      locationId: null,
      companies: new FormControl([])
    });

    this.filtersForm.valueChanges.pipe(
      debounceTime(500),
      tap(() => {
        const filters = clearEmptyProperties({
          name_contains: this.filtersForm.value.name,
          number_contains: this.filtersForm.value.number,
          equipmentType_in: this.filtersForm.value.typeId,
          location_in: this.filtersForm.value.locationId,
          company_in: this.filtersForm.value.companies,
          status_in: this.getStatus()
        });
        this.filterChanged.next(filters);
      })
    ).subscribe();

  }

  getStatus(): any {
    const name = mapCheckbox(this.filtersForm.value.status, STATUS_APPROVALS, 'name');
    if (name) {
      return name;
    }

    return null;
  }

  getPropertyValue(value, array, property): any {
    const item = _.find(array, (a) => a.id === value);
    return item[property];
  }

  clearFilters(): void {
    this.filtersForm.patchValue({
      number: null,
      name: null,
      typeId: null,
      locationId: null,
      companies: null,
      status: STATUS_APPROVALS.map((status) => {
        return status.name === 'pending';
      }),
    });
  }
}
